import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { oneOf, func, string, bool, array } from 'prop-types';

import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Segment, Button } from 'semantic-ui-react';

import Form from '~/views/common/Form';
import Heading from '~/views/common/Heading';
import Section from '~/views/common/Section';

import AuthorSelector from '~/views/common/AuthorSelector';
import LicensesForm from '~/views/common/LicensesForm';
import AddressForm from '~/views/common/AddressForm';
import ContactForm from '~/views/common/ContactForm';
import General from './General';
import Settings from './Settings';

const PortalFormComponent = ({
    header,
    submit,
    linkToView = '/col/portals',
    isPortal = false,
    isCreate,
    organizatioTypesByItem,
    licenses,
    ...rest
}) => (
    <Fragment>
        <Helmet title={`${header} Portal`} />
        <Heading
            header="Portal"
            subheader={header}
            iconName="edit"
        >
            <Button
                type="submit"
                onClick={submit}
                color="green"
                icon="save"
                content="Save"
                labelPosition="right"
            />
            <Button
                as={Link}
                to={linkToView}
                icon="cancel"
            />
        </Heading>
        <Form {...rest}>
            <Segment.Group>
                <General organizatioTypesByItem={organizatioTypesByItem} />
                <Section name="Author">
                    <Field name="author_id" component={AuthorSelector} />
                </Section>
                <Settings isCreate={isCreate} licenses={licenses} />

                { isPortal && <LicensesForm /> }

                <ContactForm />

                <AddressForm />

            </Segment.Group>
        </Form>
    </Fragment>
);

PortalFormComponent.propTypes = {
    header: oneOf(['Edit', 'Create']).isRequired,
    submit: func.isRequired,
    linkToView: string,
    isPortal: bool,
    isCreate: bool,
    organizatioTypesByItem: array.isRequired,
    licenses: array,
};


const PortalForm = reduxForm({
    form: 'PortalForm', // A unique identifier for this form
})(PortalFormComponent);

export default PortalForm;
